import React from "react";
import { WizTableForm } from '@/containers/common'
const exam = WizTableForm.Config.exam(this, { apiParams: { } })
const organization = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const position = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

//配置项
const componentName = "examReport";

function columns() {
  return [
    {
      name: "id",
    },
    {
      title: "考试名称",
      name: "title",
      tableItem: {},
    },
    {
      title: "考试名称",
      name: "examId",
      searchItem: {
        ...exam,
        diy: WizTableForm,
        selectType: 'radio',
        rules: [
          {
            required: true,
            message: '请选择考试名称'
          }
        ]
      },
    },
    {
      title: "考试分类",
      name: "examCategoryName",
      tableItem: {},
    },
    {
      title: "考试类型",
      name: "examType",
      tableItem: {},
      // searchItem: {
      //   type: 'select'
      // },
      dict: [
        { code: 0, codeName: '普通考试' },
        { code: 1, codeName: '课程考试' },
      ]
    },
    {
      title: "开始时间",
      name: "startDate",
      tableItem: {},
    },
    {
      title: "结束时间",
      name: "endDate",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm
      },
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "orgTypeName",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategoryIds",
      dict: {
        wizReplaceData: "orgNodeCategoryTree",
        defalutType: []
      },
      searchItem: {
        type: 'treeselect',
      }
    },
    {
      title: "岗位",
      name: "positionName",
      tableItem: {},
    },
    {
      title: "岗位",
      name: "positionIds",
      searchItem: {
        ...position,
        diy: WizTableForm
      },
    },
    {
      title: "应参考人数",
      name: "shoudCount",
      tableItem: {},
    },
    {
      title: "已参考人数",
      name: "factCount",
      tableItem: {},
    },
    {
      title: "参考率",
      name: "rate",
      tableItem: {
        render: text => text + '%'
      },
    },
    {
      title: "已通过人数",
      name: "passCount",
      tableItem: {},
    },
    {
      title: "通过率",
      name: "passRate",
      tableItem: {
        render: text => text + '%'
      },
    }
  ];
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort:['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false,
        }
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageListOrgPosition`,
    payload: {
      key: `${componentName}@getPageListOrgPosition`,
      apiParams: { pageNum: 1, pageSize: 10 },
    },
  },
  export: {
    path: `${componentName}/exportOrgPosition`,
    payload: {
      key: `${componentName}@exportOrgPosition`,
      apiParams: {}
    }
  },
  orgNodeCategoryTree: {
    path: `organizationNodeCategory/getTypeNodeList`,
    payload: {
      key: `${componentName}@orgNodeCategoryTree`,
      apiParams: {}
    }
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list","orgNodeCategoryTree"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
